var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_customer",
          attrs: {
            id: "modal-customer",
            title: _vm.title,
            size: "xl",
            "modal-class": "custom-modal",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.handleCancel }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.isDisabled || _vm.loading },
                          on: { click: _vm.handleOk }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n          Сохранить\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-card",
                      { attrs: { "bg-variant": "light" } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "mb-2 mt-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "12%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "20%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "50%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-3",
                                  attrs: { width: "8%", height: "24%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "30%"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "36%", height: "23%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "39%"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "10%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "43%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "10%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "43%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "10%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "43%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "16%", height: "100%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "mb-0" },
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "27%", height: "17%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "29%"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { width: "35%", height: "15%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "22%", height: "17%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "29%"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { width: "32%", height: "15%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "4%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-5" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "9%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "100%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-1" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "15%", height: "55%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "6%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "49%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-3" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "19%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "28%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-0" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "5%", height: "50%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "12%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "50%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c("b-form", [
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.collapse-customer-info",
                                  modifiers: { "collapse-customer-info": true }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [_vm._v("Данные заказчика")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-customer-info",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "align-items-end" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-town",
                                                label: "Город"
                                              }
                                            },
                                            [
                                              _c("town-select", {
                                                attrs: {
                                                  value: _vm.newItem.town_id,
                                                  "is-disabled": _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "town_id"
                                                  )
                                                },
                                                on: {
                                                  onSelect: _vm.onSelectTown
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-urflag",
                                                label: _vm.$t(
                                                  "message.customers.modal.urflagInput"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-radio-group", {
                                                attrs: {
                                                  size: "sm",
                                                  options: _vm.options,
                                                  disabled: _vm.isDisabled,
                                                  name: "radioOptions"
                                                },
                                                model: {
                                                  value: _vm.newItem.urflag,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "urflag",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.urflag"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.newItem.urflag
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "b-row",
                                            { attrs: { cols: "3" } },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group-inn",
                                                        label: _vm.$t(
                                                          "message.customers.modal.inn"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          type: "text",
                                                          size: "sm",
                                                          disabled:
                                                            _vm.isDisabled,
                                                          state: _vm.getFieldState(
                                                            "inn"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem.inn,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "inn",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.inn"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group-kpp",
                                                        label: _vm.$t(
                                                          "message.customers.modal.kpp"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          type: "text",
                                                          size: "sm",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem.kpp,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "kpp",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.kpp"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group-ogrn",
                                                        label: _vm.$t(
                                                          "message.customers.modal.ogrn"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          type: "text",
                                                          size: "sm",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem.ogrn,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "ogrn",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.ogrn"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "custom-btn-secondary mb-2 mt-1",
                                              attrs: {
                                                disabled:
                                                  _vm.isEmpty(
                                                    _vm.newItem.inn
                                                  ) ||
                                                  _vm.isDisabled ||
                                                  _vm.isLookingUpParty
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.findCustomerData()
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  name: "buttons/fill",
                                                  size: 13
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Заполнить данными\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c("div"),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Полное наименование"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input-full-name",
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.full_name,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "full_name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.full_name"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label:
                                                  "Сокращённое наименование"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "name"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.name,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.name"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            { attrs: { label: "Адрес" } },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.$t(
                                                    "message.customers.modal.addressPlaceholder"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.address,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "address",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.address"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "align-items-end" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-status",
                                                label: "Статус заказчика"
                                              }
                                            },
                                            [
                                              _c("customer-status-select", {
                                                attrs: {
                                                  value: _vm.newItem.status_id,
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                on: {
                                                  onSelect:
                                                    _vm.onSelectCustomerStatus
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-marketing-source",
                                                label: "Источник"
                                              }
                                            },
                                            [
                                              _c("marketing-source-select", {
                                                attrs: {
                                                  value:
                                                    _vm.newItem
                                                      .marketing_source_id,
                                                  "is-disabled": _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "marketing_source_id"
                                                  )
                                                },
                                                on: {
                                                  onSelect:
                                                    _vm.onSelectMarketingSource
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-marketing-source-comment",
                                                label: "Источник комментарий"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .marketing_source_comment,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "marketing_source_comment",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.marketing_source_comment"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "group-description",
                                        label: _vm.$t(
                                          "message.customers.modal.descriptionInput"
                                        )
                                      }
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          size: "sm",
                                          disabled: _vm.isDisabled,
                                          placeholder: _vm.$t(
                                            "message.customers.modal.descriptionPlaceholder"
                                          ),
                                          rows: 3,
                                          "max-rows": 6
                                        },
                                        model: {
                                          value: _vm.newItem.description,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.newItem,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "newItem.description"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName:
                                    "v-b-toggle.collapse-customer-bank-details",
                                  modifiers: {
                                    "collapse-customer-bank-details": true
                                  }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [_vm._v("Банковские реквизиты")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-customer-bank-details",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  _c(
                                    "b-row",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-bik",
                                                label: _vm.$t(
                                                  "message.customers.modal.bik"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.bik,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "bik",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.bik"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-cor-account",
                                                label: _vm.$t(
                                                  "message.customers.modal.cor_account"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.cor_account,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "cor_account",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.cor_account"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-bank",
                                                label: _vm.$t(
                                                  "message.customers.modal.bank"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.bank,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "bank",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.bank"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-checking-account",
                                                label: _vm.$t(
                                                  "message.customers.modal.checking_account"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .checking_account,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "checking_account",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.checking_account"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "2" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            { attrs: { label: "Скидки" } },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "number",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.sale,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "sale",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "newItem.sale"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName:
                                    "v-b-toggle.collapse-customer-contacts",
                                  modifiers: {
                                    "collapse-customer-contacts": true
                                  }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [_vm._v("Контакты")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-customer-contacts",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  !_vm.isDisabled &&
                                  _vm.newItem.contacts.length === 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "text-small text-danger"
                                        },
                                        [
                                          _vm._v(
                                            "Добавьте хотя бы один заполненный контакт."
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isBusyContacts ||
                                  (_vm.newItem.contacts &&
                                    _vm.newItem.contacts.length > 0)
                                    ? [
                                        _c("b-table", {
                                          ref: "customer_contacts",
                                          staticClass:
                                            "custom-table mb-0 text-small text-center",
                                          attrs: {
                                            id: "customer-contacts",
                                            responsive: "",
                                            busy: _vm.isBusyContacts,
                                            items: _vm.newItem.contacts,
                                            fields: _vm.contactsFields
                                          },
                                          on: {
                                            "update:busy": function($event) {
                                              _vm.isBusyContacts = $event
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "table-busy",
                                                fn: function() {
                                                  return [
                                                    _c("tables-skeleton", {
                                                      attrs: {
                                                        fields:
                                                          _vm.contactsFields,
                                                        rows: 2
                                                      }
                                                    })
                                                  ]
                                                },
                                                proxy: true
                                              },
                                              {
                                                key: "cell(phone)",
                                                fn: function(row) {
                                                  return [
                                                    _c(
                                                      "b-input-group",
                                                      {
                                                        attrs: {
                                                          size: "sm",
                                                          prepend: _vm.phoneInputPrefix(
                                                            row.item.phone
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            id: "input-phone",
                                                            type: "tel",
                                                            size: "sm",
                                                            autocomplete: "off",
                                                            placeholder: _vm.$t(
                                                              "message.customers.modal.phonePlaceholder"
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              row.item.phone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row.item,
                                                                "phone",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row.item.phone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "cell(name)",
                                                fn: function(row) {
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "input-name",
                                                        size: "sm",
                                                        autocomplete: "off"
                                                      },
                                                      model: {
                                                        value: row.item.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.name"
                                                      }
                                                    })
                                                  ]
                                                }
                                              },
                                              {
                                                key: "cell(email)",
                                                fn: function(row) {
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "input-email",
                                                        size: "sm",
                                                        autocomplete: "off"
                                                      },
                                                      model: {
                                                        value: row.item.email,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.email"
                                                      }
                                                    })
                                                  ]
                                                }
                                              },
                                              {
                                                key: "cell(description)",
                                                fn: function(row) {
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "input-description",
                                                        size: "sm",
                                                        autocomplete: "off"
                                                      },
                                                      model: {
                                                        value:
                                                          row.item.description,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "description",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.description"
                                                      }
                                                    })
                                                  ]
                                                }
                                              },
                                              {
                                                key: "cell(action)",
                                                fn: function(row) {
                                                  return [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "link",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeContact(
                                                              row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", {
                                                          attrs: {
                                                            name:
                                                              "buttons/trash",
                                                            size: 16
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1489035721
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-link",
                                          {
                                            staticClass:
                                              "d-flex align-items-center text-decoration-none text-success text-small pt-3",
                                            attrs: { disabled: _vm.isDisabled },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.addContact.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "buttons/plus",
                                                size: 13
                                              }
                                            }),
                                            _vm._v(
                                              "\n                    Добавить\n                  "
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "empty-state-container"
                                        },
                                        [
                                          _c("v-icon", {
                                            attrs: {
                                              name: "navbar/empty_table",
                                              size: 90
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("h5", [
                                            _vm._v("Нет добавленных контактов.")
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Добавьте контакты прямо сейчас"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-btn",
                                            {
                                              staticClass:
                                                "custom-btn-primary mt-1",
                                              attrs: {
                                                disabled: _vm.isDisabled
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.addContact.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  name: "buttons/plus",
                                                  size: 12
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Новый контакт\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66f8dea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f8dea8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Customer.vue
// module id = null
// module chunks = 